import { toAbsoluteUrl } from '../utils/utils'

export const initLayoutConfig = {
  // == Base Layout
  self: {
    layout: 'fluid',
    // body: { "background-image": toAbsoluteUrl("/media/misc/bg-1.jpg") },
    logo: {
      dark: toAbsoluteUrl('/media/logos/logo-light.svg'),
      light: toAbsoluteUrl('/media/logos/logo-dark.svg'),
      brand: toAbsoluteUrl('/media/logos/logo-light.svg'),
      green: toAbsoluteUrl('/media/logos/logo-light.svg'),
    },
    favicon: {
      dark: toAbsoluteUrl('/media/logos/favicon.ico'),
      light: toAbsoluteUrl('/media/logos/favicon.ico'),
      brand: toAbsoluteUrl('/media/logos/favicon.ico'),
    },
  },
  // == Portlet Plugin
  // portlet: {
  //   sticky: {
  //     offset: 50
  //   }
  // },
  // == Page Splash Screen loading
  loader: {
    enabled: true,
    type: 'spinner-logo',
    logo: toAbsoluteUrl('/media/logos/logo-mini-md.png'),
    message: 'Please wait...',
  },
  // == Colors for javascript
  colors: {
    state: {
      brand: 'var(--aug-product-blue)',
      dark: 'var(--aug-chrome-navy)',
      light: 'var(--aug-surface-raised)',
      primary: 'var(--aug-product-blue)',
      success: 'var(--bs-success)',
      info: 'var(--bs-info)',
      warning: 'var(--bs-warning)',
      danger: 'var(--bs-danger)',
    },
    base: {
      label: [
        'var(--aug-color-label-2)',
        'var(--aug-color-label-3)',
        'var(--aug-text-charcoal)',
        'var(--aug-text-body-bs)',
      ],
      shape: [
        'var(--aug-color-shape-1)',
        'var(--aug-color-shape-2)',
        'var(--aug-color-shape-3)',
        'var(--aug-color-grey-4)',
      ],
    },
  },
  // page toolbar
  toolbar: {
    display: true,
  },
  header: {
    self: {
      width: 'fluid', // fixed|fluid
      skin: 'dark',
      fixed: {
        desktop: true,
        mobile: true,
      },
    },
    menu: {
      self: {
        display: true,
        layout: 'default',
        'root-arrow': false,
        'icon-style': 'duotone',
      },
      desktop: {
        arrow: true,
        toggle: 'click',
        submenu: {
          skin: 'dark',
          arrow: true,
        },
      },
      mobile: {
        submenu: {
          skin: 'dark',
          accordion: true,
        },
      },
    },
  },
  subheader: {
    display: true,
    displayDesc: false,
    displayDaterangepicker: true,
    layout: 'subheader-v1',
    fixed: true,
    width: 'fluid', // fixed|fluid,
    clear: false,
    style: 'solid',
  },
  content: {
    width: 'fluid',
  },
  brand: {
    self: {
      skin: 'light',
    },
  },
  aside: {
    self: {
      skin: 'light',
      display: true,
      fixed: true,
      minimize: {
        toggle: true,
        default: false,
      },
    },
    footer: {
      self: {
        display: true,
      },
    },
    menu: {
      dropdown: false,
      scroll: false,
      'icon-style': 'duotone',
      submenu: {
        accordion: true,
        dropdown: {
          arrow: true,
          'hover-timeout': 100,
        },
      },
    },
  },
  footer: {
    self: {
      width: 'fluid',
      fixed: false,
    },
  },
}

const LayoutConfig = JSON.parse(JSON.stringify(initLayoutConfig)) // deep object copy
export default LayoutConfig
